// @ts-nocheck
import React, { useContext } from 'react';
import { Row, Card, Col } from 'antd';

// CUSTOM MODULES
import PageTitle from 'shared_components/page_title';
import { ContactsImage, UserImage, SignFormImage, EmployeeImage } from 'images';
import UserMaintenanceCard from './setup_maintenance_card';

import './setup-maintenance-menu.css';
import { UserAccessContext } from 'context/userAccess';

const settingsItemData = [
	{
		image: EmployeeImage,
		link: '/customer/search',
		label: 'CUSTOMER SETUP',
	},
	{
		image: UserImage,
		link: '/agent/search',
		label: 'AGENT SETUP',
	},
	{
		image: SignFormImage,
		link: '/lookuptable',
		label: 'LOOKUP TABLE',
	},
	{
		image: ContactsImage,
		link: '/system_setup',
		label: 'SYSTEM SETUP',
	},
	{
		image: EmployeeImage,
		link: '/',
		label: 'MENU 3',
	},
	{
		image: UserImage,
		link: '/',
		label: 'MENU 4',
	},
];

function SetupMaintenanceMenu() {
	const { userAccess } = useContext(UserAccessContext);
	let viewRight;

	const rowItems = settingsItemData.map(el => {
		const checkAccess = (moduleAccess) => {
			switch (moduleAccess) {
				case 'CUSTOMER SETUP':
					viewRight = userAccess['customersSetup'].view;
					return(viewRight)
				case 'AGENT SETUP':
					viewRight = userAccess['agents'].view;
					return(viewRight)
				case 'LOOKUP TABLE':
					viewRight = userAccess['lkpSetup'].view;
					return(viewRight)
				case 'SYSTEM SETUP':
					viewRight = userAccess['systemSetup'].view;
					return(viewRight)
				default:
					return 'FALSE';
			}
		}
		if(checkAccess(el.label) === 'FALSE'){
			return(
				<></>
			)
		}else{
			return (
				<UserMaintenanceCard
					image={el.image}
					link={el.link}
					label={el.label}
					offset={el.offset}
					className=""
					key={el.label}
				/>
			);
		}
	});

	return (
		<div style={{ textAlign: 'center' }}>
			<div style={{ marginTop: 20 }}>
				<PageTitle pageTitle="SETUP MAINTENANCE" />
			</div>
			<Col>
				<Card>
					<Row gutter={20} style={{ paddingTop: '10px' }}>
						{rowItems}
					</Row>
				</Card>
			</Col>
		</div>
	);
}

export default SetupMaintenanceMenu;
